import { Hidden } from '@material-ui/core';
import React, { useState } from 'react';
import { QuickMenuBar } from './QuickMenuBar';
import { QuickMenuDialog } from './QuickMenuDialog';

export enum DialogContentType {
	INFO = 'info',
	CONTACT = 'contact',
	VIDEO = 'video',
}

/**
 * Quick Menu Button Bar and Overlay
 */
export const QuickMenu: React.FC = () => {

	const [showDialog, setShowDialog] = useState(false);
	const [activeEntry, setActiveEntry] = useState<DialogContentType | null>(null);

	const handleClose = () => {
		setShowDialog(false);
	};

	const handleClick = (tab: DialogContentType) => {
		if (showDialog && tab === activeEntry) {
			handleClose();
		} else {
			setActiveEntry(tab);
			setShowDialog(true);
		}
	};

	return (
		<Hidden xsDown implementation="js">
			<QuickMenuBar
				handleClick={handleClick}
				open={showDialog}
				activeEntry={activeEntry}
			/>
			<QuickMenuDialog
				open={showDialog}
				handleClose={handleClose}
				activeEntry={activeEntry}
			/>
		</Hidden>
	);
};
